import React, { CSSProperties } from 'react';

interface ApoelVisaProps {
  style?: CSSProperties;
}

export default function ApoelVisa({ style }: ApoelVisaProps) {
  return (
    <img 
      src="https://www.bankofcyprus.com/globalassets/start/retail/cards/new-site-images/2apoel-visa-prepaid-200.png" 
      alt="ΑΠΟΕΛ Visa" 
      style={{ width: '75px', height: '47px', ...style }}
    />
  );
}
